import { clsx } from 'clsx';
import React, { useState, useMemo } from 'react';
import { SecondaryNavContext } from './SecondaryNavContext.es.js';
import { SecondaryNavItem } from './SecondaryNavItem.es.js';
import { SecondaryNavList } from './SecondaryNavList.es.js';
import { SecondaryNavTitle } from './SecondaryNavTitle.es.js';

const secondaryNav = "_secondary-nav_clfmr_1";
const styles = {
	secondaryNav: secondaryNav
};

const SecondaryNavRoot = ({ children, className, defaultSelectedItem = null, defaultExpandedKeys = [], selectedItem, onSelectedItemChange, expandedKeys, onExpandedKeysChange }) => {
  const [localSelectedItem, setLocalSelectedItem] = useState(defaultSelectedItem);
  const [localExpandedKeys, setLocalExpandedKeys] = useState(defaultExpandedKeys);
  const isSelectedItemControlled = !!selectedItem;
  const isExpandedKeysControlled = !!expandedKeys;
  const currentSelectedItem = selectedItem !== null && selectedItem !== void 0 ? selectedItem : localSelectedItem;
  const currentExpandedKeys = expandedKeys !== null && expandedKeys !== void 0 ? expandedKeys : localExpandedKeys;
  const state = useMemo(() => ({
    selectedItemKey: currentSelectedItem,
    expandedSectionKeys: currentExpandedKeys,
    registerSelectedItemKey: (key) => {
      onSelectedItemChange === null || onSelectedItemChange === void 0 ? void 0 : onSelectedItemChange(key);
      if (!isSelectedItemControlled) {
        setLocalSelectedItem(key);
      }
    },
    registerExpandedSectionKeys: (keys) => {
      onExpandedKeysChange === null || onExpandedKeysChange === void 0 ? void 0 : onExpandedKeysChange(keys);
      if (!isExpandedKeysControlled) {
        setLocalExpandedKeys(keys);
      }
    }
  }), [
    currentSelectedItem,
    currentExpandedKeys,
    isSelectedItemControlled,
    isExpandedKeysControlled,
    onSelectedItemChange,
    onExpandedKeysChange
  ]);
  return React.createElement(
    SecondaryNavContext.Provider,
    { value: state },
    React.createElement("nav", { className: clsx(styles.secondaryNav, className), "data-zds": true }, children)
  );
};
const SecondaryNav = Object.assign(SecondaryNavRoot, {
  Title: SecondaryNavTitle,
  Item: SecondaryNavItem,
  List: SecondaryNavList
});

export { SecondaryNav, SecondaryNavRoot, SecondaryNav as default };
//# sourceMappingURL=SecondaryNav.es.js.map
